import Carousel from 'react-bootstrap/Carousel';

const IMG_NAVE_NUEVA_URL = new URL("../../img/bienvenida/nave.jpg", import.meta.url).href;
// const IMG_NAVE_ANTIGUA_URL = new URL("../../img/bienvenida/nave_antigua.jpg", import.meta.url).href;
const IMG_INTERIOR_1_URL = new URL("../../img/bienvenida/interior_nave_1.jpg", import.meta.url).href;
const IMG_INTERIOR_2_URL = new URL("../../img/bienvenida/interior_nave_2.jpg", import.meta.url).href;
const INTERVAL_IN_MILISECONDS = 2000;

const PaginaPrincipal = () => {

    const INTERVAL_IN_MILISECONDS = 2000;
    return (
        <div className="centerDiv">
            <a
                className="btn btn-outline-primary btn-lg center"
                href="https://www.goyanesonline.com/"
                target="_blank"
                rel="noopener noreferrer"
            >
                Visita nuestra Tienda Online
            </a>
            <Carousel className="carrousel">
                <Carousel.Item interval={INTERVAL_IN_MILISECONDS}>
                <img
                    className="paginaPrincipalImagen"
                    src={IMG_NAVE_NUEVA_URL}
                    alt="First slide"
                />
                </Carousel.Item>
                {/* <Carousel.Item interval={INTERVAL_IN_MILISECONDS}>
                <img
                    className="paginaPrincipalImagen"
                    src={IMG_NAVE_ANTIGUA_URL}
                    alt="First slide"
                />
                </Carousel.Item> */}
                <Carousel.Item interval={INTERVAL_IN_MILISECONDS}>
                <img
                    className="paginaPrincipalImagen"
                    src={IMG_INTERIOR_1_URL}
                    alt="First slide"
                />
                </Carousel.Item>
                <Carousel.Item interval={INTERVAL_IN_MILISECONDS}>
                <img
                    className="paginaPrincipalImagen"
                    src={IMG_INTERIOR_2_URL}
                    alt="First slide"
                />
                </Carousel.Item>
            </Carousel>
        </div>
    );
};

export default PaginaPrincipal;
